/**
 * Cart gift tiers indicator (snippets/cart-gift-indicator.liquid)
 *
 * Mirrors the free shipping bar: recalculates on every `theme:cart:change`
 * using the same subtotal source ([data-cart-total]) that theme.js reads.
 */
(() => {
  if (customElements.get('cart-gift-indicator')) return;

  const selectors = {
    cartTotal: '[data-cart-total]',
    tiersJson: '[data-gift-tiers-json]',
    tier: '[data-gift-tier]',
    fill: '[data-gift-fill]',
    band: '[data-gift-band]',
    success: '[data-gift-success]',
    more: '[data-gift-more]',
  };

  const attributes = {
    cartTotal: 'data-cart-total',
  };

  const classes = {
    reached: 'is-reached',
    next: 'is-next',
    later: 'is-later',
  };

  class CartGiftIndicator extends HTMLElement {
    constructor() {
      super();

      this.onCartChange = this.onCartChange.bind(this);
    }

    connectedCallback() {
      const tiersJson = this.querySelector(selectors.tiersJson);

      try {
        this.tiers = tiersJson ? JSON.parse(tiersJson.textContent) : [];
      } catch (error) {
        this.tiers = [];
      }

      if (!this.tiers.length) return;

      const rate = Number(window.Shopify?.currency?.rate) || 1;
      this.tiers.forEach((tier) => {
        tier.threshold *= rate;
        tier.windowStart *= rate;
      });

      this.tierElements = this.querySelectorAll(selectors.tier);
      this.band = this.querySelector(selectors.band);
      this.success = this.querySelector(selectors.success);
      this.more = this.querySelector(selectors.more);

      document.addEventListener('theme:cart:change', this.onCartChange);
    }

    disconnectedCallback() {
      document.removeEventListener('theme:cart:change', this.onCartChange);
    }

    onCartChange(event) {
      const cartTotal = document.querySelector(selectors.cartTotal);
      if (!cartTotal) return;

      const cartCount = event.detail?.cartCount;
      if (typeof cartCount === 'number') {
        this.hidden = cartCount === 0;
      }

      this.update(parseInt(cartTotal.getAttribute(attributes.cartTotal)) || 0);
    }

    update(subtotal) {
      let previousThreshold = 0;
      let nextFound = false;
      let moreMessage = '';
      let successMessage = '';

      this.tiers.forEach((tier, index) => {
        const element = this.tierElements[index];
        let state = classes.later;
        let fill = 0;

        if (subtotal >= tier.threshold) {
          state = classes.reached;
          fill = 100;
          if (tier.success) successMessage = tier.success;
        } else if (!nextFound) {
          nextFound = true;
          state = classes.next;
          fill = Math.max(((subtotal - previousThreshold) / (tier.threshold - previousThreshold)) * 100, 0);

          if (subtotal >= tier.windowStart && tier.message) {
            const remaining = window.formatMoney(tier.threshold - subtotal, window.theme.moneyFormat);
            moreMessage = tier.message.replace('||amount||', remaining);
          }
        }

        previousThreshold = tier.threshold;

        if (!element) return;
        element.classList.remove(classes.reached, classes.next, classes.later);
        element.classList.add(state);
        element.querySelector(selectors.fill)?.style.setProperty('width', `${fill.toFixed(1)}%`);
      });

      if (this.success) {
        this.success.hidden = !successMessage;
        this.success.innerHTML = successMessage;
      }

      if (this.more) {
        this.more.hidden = !moreMessage;
        this.more.innerHTML = moreMessage;
      }

      if (this.band) this.band.hidden = !successMessage && !moreMessage;
    }
  }

  customElements.define('cart-gift-indicator', CartGiftIndicator);
})();
